import axios from 'axios';

import { API_ST_TICKER } from 'constants/api';

import RequestCache from './request-cache';

// Display conversion only; transaction quotes use their own live endpoints.
const displayPrice = new RequestCache<number>(15_000);

export const getLumenUsdPrice = (): Promise<number> =>
    displayPrice.get(API_ST_TICKER, async () => {
        const { data } = await axios.get<{ _meta: { externalPrices: { USD_XLM: number } } }>(
            `${API_ST_TICKER}?${Math.random()}`,
        );
        return data._meta.externalPrices.USD_XLM;
    });
